import { memoizeFunction } from './druid/./druid/Utilities';
import { mergeStyles } from './druid/./druid/Styling';

export interface IDraggableZoneStyles {
  root: string;
}

export const getClassNames = memoizeFunction(
  (className: string, isDragging: boolean): IDraggableZoneStyles => {
    return {
      root: mergeStyles(
        className,
        isDragging && {
          touchAction: 'none',
          selectors: {
            '& *': {
              userSelect: 'none',
            },
          },
        },
      ),
    };
  },
);
